'use strict';

var stringify = require('./stringify');
var parse = require('./parse');
var formats = require('./formats');

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};



// WEBPACK FOOTER //
// ./~/instantsearch.js/~/qs/lib/index.js